import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import Pagination from './Pagination';

export type Props = {
  title: JsxNode;
  setPage: (v: number) => void;
  titleActions?: JsxNode;
  actions?: JsxNode;
  paginationActions?: JsxNode;
  children?: JsxNode;
  currentPage?: number;
  limit?: number;
  count?: number;
};

export default function TableHeader({
  children,
  titleActions,
  actions,
  paginationActions,
  title,
  setPage,
  currentPage,
  limit,
  count,
}: Props) {
  const renderTitle = () => {
    if (typeof title !== 'string') {
      return title;
    }
    return (
      <Typography variant="h4" component="h1">
        {title}
      </Typography>
    );
  };

  const renderChildren = () => {
    if (!children) {
      return null;
    }
    return <Box flexGrow={1}>{children}</Box>;
  };

  const renderActions = () => {
    if (!actions) {
      return null;
    }
    return <Box ml={{ xs: 0, md: 2 }}>{actions}</Box>;
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        position: 'sticky',
        top: 47,
        bgcolor: 'common.white',
        py: 1,
        px: 2,
        borderBottom: '1px solid',
        borderBottomColor: 'divider',
        zIndex: 10,
      }}
    >
      <Stack direction="row" spacing={{ xs: 2, md: 4 }} alignItems="center">
        {renderTitle()}
        {titleActions || null}
      </Stack>
      {renderChildren()}
      <Box display="flex" alignItems="center">
        <Pagination
          setPage={setPage}
          currentPage={currentPage}
          limit={limit}
          count={count}
          actions={paginationActions}
        />
        {renderActions()}
      </Box>
    </Stack>
  );
}
